<script lang="ts">
  import type { Idea } from '$lib/idea';
  import { formatDate } from '$lib/gtd';

  interface Props { idea: Idea; onOpen: (idea: Idea) => void }
  let { idea, onOpen }: Props = $props();
</script>

<button type="button" class="item" style="width:100%;text-align:left" onclick={() => onOpen(idea)}>
  <div style="flex:1;min-width:0">
    <div class="item-text">{idea.texto}</div>
    <div class="item-meta">
      {#if idea.pendienteRevision}<span class="tag tag-priority-high">sin revisar</span>{/if}
      {#if idea.origen.autor !== 'carlos'}<span class="tag tag-context">{idea.origen.autor}</span>{/if}
      {#if idea.propuesta}<span class="tag">propuesta: {idea.propuesta.tipo}</span>{/if}
      {#if idea.destino}<span class="tag">→ {idea.destino.tipo}{idea.destino.ref ? ` · ${idea.destino.ref}` : ''}</span>{/if}
      {#each idea.tags as t}<span class="tag">#{t}</span>{/each}
      <span>{formatDate(idea.updatedAt)}</span>
    </div>
  </div>
</button>
